import clubhouse from '../Resource/clubhouse.jpg';
import sustainability from '../Resource/sustainability.png';

import sharma from '../Resource/MapInfo/shama.png'
import sharma1 from '../Resource/MapInfo/shama-img1.png'
import sharma2 from '../Resource/MapInfo/shama-img2.png'

import suvidha from '../Resource/MapInfo/suvidha.png'
import suvidha1 from '../Resource/MapInfo/suvidha-img1.png'
import suvidha2 from '../Resource/MapInfo/suvidha-img2.png'


import madhur from '../Resource/MapInfo/madhur.png'
import madhur1 from '../Resource/MapInfo/madura-img1.png'
import madhur2 from '../Resource/MapInfo/madura-img2.png'

import sukhee from '../Resource/MapInfo/sukhee.png'
import sukhee1 from '../Resource/MapInfo/sukhee-img1.png'

import milan from '../Resource/MapInfo/milan.png'
import milan1 from '../Resource/MapInfo/milan-img1.png'
 
// export const mapInfoData = {
//   Sharma: {
//     title: "Sharma",
// description:
//       "Sharma is a luxurious resort offering a perfect blend of comfort and nature. Ideal for peaceful getaways with serene views and cozy stays.",    buttonText: "Contact Us",
//     leftImage: sharma,
//     sliderImages: [
//       clubhouse,
//       sustainability,
//       clubhouse,
//       sustainability,
//       clubhouse
//     ],
//   },
//   Suvidha: {
//     title: "Suvidha",
// description:
//       "Suvidha resort offers a tranquil experience amidst lush greenery. Enjoy modern amenities while staying close to nature's beauty.",
//     buttonText: "Enquire Now",
//     leftImage: suvidha,
//     sliderImages: [
//       sustainability,
//       clubhouse,
//       clubhouse,
//       sustainability
//     ],
//   },
//   Milan: {
//     title: "Milan",
//  description:
//       "Milan resort is ideal for both business retreats and family vacations. Spacious rooms, scenic views, and top-tier hospitality await.",    buttonText: "Enquire",
//     leftImage: milan,
//     sliderImages: [
//       clubhouse,
//       sustainability,
//       clubhouse,
//       clubhouse
//     ],
//   },
//   Madhur: {
//     title: "Madhur",
// description:
//       "Experience elegance and comfort at Madhur resort. A perfect choice for couples and families seeking relaxation and luxury together.",    buttonText: "Contact Us",
//     leftImage: madhur,
//     sliderImages: [
//       sustainability,
//       clubhouse,
//       sustainability,
//       clubhouse,
//       clubhouse,
//       sustainability
//     ],
//   },
//   Sukhee: {
//     title: "Sukhee",
// description:
//       "Sukhee resort provides a rejuvenating escape into nature with eco-friendly stays and serene surroundings for a peaceful vacation.",      buttonText: "Enquire Now",
//     leftImage: sukhee,
//     sliderImages: [
//       clubhouse,
//       sustainability,
//       clubhouse,
//       clubhouse
//     ],
//   },
// };

export const mapInfoData = {
  Sukhee: {
    title: "Sukhee",
    description:
      "Poolside lagoon rooms with tranquil views and lush landscaping—ideal for vacation-style living and relaxation.",
    buttonText: "Contact Us",
    leftImage: sukhee,
    sliderImages: [
      sukhee1
    ],
  },
  Shama: {
    title: "Shama",
    description:
      "Ultra-luxurious living with sophisticated spaces, upscale amenities, and a perfect blend of privacy and elegance.",
    buttonText: "Notify Me",
    leftImage: sharma,
    sliderImages: [
      sharma2,
    ],
  },
  Suvidh: {
    title: "Suvidh",
    description:
      "Luxurious retirement homes with serene surroundings, natural light, premium fittings, and an active senior lifestyle focus.",
    buttonText: "Notify Me",
    leftImage: suvidha,
    sliderImages: [
      suvidha1,
      suvidha2,
    ],
  },
  Milan: {
    title: "Milan",
    description:
      "Suite-style rooms with private pools offering boutique luxury and complete privacy, ideal for comfort seekers.",
    buttonText: "Notify Me",
    leftImage: milan,
    sliderImages: [
      milan1,
    ],
  },
  Madhur: {
    title: "Madhur",
    description:
      "Stylish butterfly-style studio rooms with a terrace pool—compact, elegant, and perfect for aesthetic living.",
    buttonText: "Notify Me",
    leftImage: madhur,
    sliderImages: [
      madhur1,
      madhur2
    ],
  },
  
};
